import { library, dom, config } from "@fortawesome/fontawesome-svg-core";

import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { fad } from "@fortawesome/pro-duotone-svg-icons";

config.autoReplaceSvg = "nest";

library.add(fad);
library.add(fas);
library.add(far);
library.add(fal);

dom.watch();

export function getListIcons() {
  return Object.keys(fal);
}

// iconName exact (ex: "user-plus"), tel que défini par fontawesome
export function getIconNames() {
  return Array.from(new Set(Object.values(fal).map((definition) => definition.iconName)));
}
